import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { ViewerConfigurationService } from "../viewer-configuration.service";

@Injectable({
  providedIn: "root",
})
export class ApiViewerService {
  constructor(
    private viewerConfigurationService: ViewerConfigurationService,
    private http: HttpClient,
  ) {}

  public get apiUrl(): string {
    return this.viewerConfigurationService.getViewerConfiguration().geoserverUrl;
  }

  public get authToken(): string {
    return this.viewerConfigurationService.getViewerConfiguration().token;
  }

  public get authType(): string {
    return this.viewerConfigurationService.getViewerConfiguration().authType;
  }

  public get queryParam(): string {
    return this.authType;
  }

  public get queryAuth(): string {
    return this.queryParam + "=" + this.authToken;
  }

  public get headers(): any {
    return {
      Authorization: this.queryAuth,
    };
  }
}
